import http from "../../utils/http";

// 가족 정보 목록
export const getEmployeeFamilyList = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/employees/families/list`, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 가족 정보 등록
export const createEmployeeFamily = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/employees/families`, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 가족 정보 수정
export const modifyEmployeeFamily = (familyIdx, params) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/employees/families/${familyIdx}`, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 가족 정보 삭제
export const deleteEmployeeFamily = (familyIdx, employeeIdx) => {
  return new Promise((resolve, reject) => {
    http
      .delete(`/employees/families/${familyIdx}/${employeeIdx}`)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
